
/* START_TEMPLATE */
define('hbs!pricelist/templates/side-bar',['hbs','handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
helpers = helpers || Handlebars.helpers;
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n  	<button id=\"addition\" class=\"btn\"><i class=\"icon-info-sign\"></i> Pristillägg</button>\r\n  	<button id=\"supplement\" class=\"btn\"><i class=\"icon-book\"></i> Annonsbilagepris</button>\r\n  	<button id=\"editorialschedule\" class=\"btn\"><i class=\"icon-calendar\"></i> Utgivningsplan</button>\r\n	";
  stack1 = helpers['if'].call(depth0, depth0.moduleMap, {hash:{},inverse:self.noop,fn:self.program(2, program2, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n		<a href=\"";
  if (stack1 = helpers.moduleMap) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.moduleMap; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "\" id=\"modulemap\" class=\"btn\" target=\"_blank\"><i class=\"icon-th\"></i> Modulkarta</a>\r\n	";
  return buffer;
  }

function program4(depth0,data) {
  
  
  return "\r\n    <button id=\"booking\" class=\"btn\" style=\"display:none\"><i class=\"icon-info-sign\"></i> Bokning</button>\r\n  ";
  }

function program6(depth0,data) {
  
  
  return "\r\n    <button id=\"information\" class=\"btn\"><i class=\"icon-info-sign\"></i> Upplysningar</button>\r\n  ";
  }

  buffer += "<div>\r\n<!-- Skipping ordering for now\r\n	<h4>Order</h4>\r\n	<label><span>Section first:</span><input type=\"radio\" name=\"order-first\" id=\"section-first\" value=\"SPfvicr\"></label>\r\n	<label><span>Position first:</span><input type=\"radio\" name=\"order-first\" id=\"position-first\"  value=\"PSfvicr\"></label>\r\n	<label><span>Format first:</span><input type=\"radio\" name=\"order-first\" id=\"format-first\" value=\"FSpvicr\"></label>\r\n-->\r\n	<button id=\"discount\" class=\"btn\"><i class=\"icon-bookmark\"></i> Rabatter</button>\r\n  ";
  stack1 = helpers['if'].call(depth0, depth0.isPrint, {hash:{},inverse:self.noop,fn:self.program(1, program1, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n  ";
  stack1 = helpers.unless.call(depth0, depth0.isPrint, {hash:{},inverse:self.noop,fn:self.program(4, program4, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n  ";
  stack1 = helpers['if'].call(depth0, depth0.hasMediaId, {hash:{},inverse:self.noop,fn:self.program(6, program6, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n</div>";
  return buffer;
  });
Handlebars.registerPartial('pricelist_templates_side-bar', t);
return t;
});
/* END_TEMPLATE */
;
